import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b5e6347"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "22",
  height: "22",
  viewBox: "0 0 35 35",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("line", {
    x1: "26.7906",
    y1: "9.40166",
    x2: "9.4015",
    y2: "26.7908",
    stroke: "white",
    "stroke-width": "2"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "8.73274",
    y1: "8.65633",
    x2: "26.1218",
    y2: "26.0454",
    stroke: "white",
    "stroke-width": "2"
  })
], -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "text-white font-light text-xl text-left" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "self-start text-3xl mb-4" }, " Burn Rules ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "self-start text-base mb-4 text-red-500" }, " All of the following are required ", -1))
const _hoisted_6 = { class: "text-sm max-w-sm" }
const _hoisted_7 = ["href"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }

import { useInjectTopLevelProps } from '@/exports/MBurnRedeemCompleteWidgetProps';
import {
  ref, watchEffect,
} from 'vue';
import { BurnItemOnChain, BurnGroupOnChain } from '@/classes/burnRedeemExtensionCore';
import { abbreviateAddress, convertPotentialWeb3ProtocolToWeb2 } from '@/lib/util';
import Modal from '@/components/Modal.vue';
import Creator721Contract from '@/classes/creator721Contract';
import Creator1155Contract from '@/classes/creator1155Contract';
import { useBR } from '@/composables/useBR';

interface CoalescedBurnGroupOnChain extends BurnGroupOnChain {
  contractName: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BurnRulesModal',
  emits: ['close'],
  setup(__props, { emit }) {

const { network } = useInjectTopLevelProps();

const burnGroupDescriptions = ref<string[]>([]);

const coalcescedBurnGroups = ref<CoalescedBurnGroupOnChain[]>([]);

const { burn, studioInstance } = useBR();

const getBurnItemLink = (item: BurnItemOnChain) => {
  if (item.validationType === 2 && item.minTokenId?.toString() === item.maxTokenId?.toString()) {
    return `https://${network === 5 ? 'testnets.' : ''}opensea.io/assets/${
      network === 5 ? 'goerli' : 'ethereum'
    }/${item.contractAddress}/${item.minTokenId}`;
  }

  return `https://${network === 5 ? 'testnets.' : ''}opensea.io/assets/${
    network === 5 ? 'goerli' : 'ethereum'
  }/${item.contractAddress}`;
};

const getBurnGroupDescription = async (group: CoalescedBurnGroupOnChain): Promise<string> => {
  if (!burn.value) {
    return '';
  }

  const onChainItem = group.items[0];

  if (onChainItem.validationType === 1) {
    return 'All Tokens';
  }

  if (onChainItem.validationType === 2) {
    if (onChainItem.minTokenId?.toString() === onChainItem.maxTokenId?.toString()) {
      let jsonMetadata;

      try {
        let uri = '';
        if (onChainItem.tokenSpec === 1) {
          // single erc721 burn
          const c = new Creator721Contract(onChainItem.contractAddress);
          uri = await c.tokenURI(onChainItem.minTokenId?.toString() || '');
        }

        if (onChainItem.tokenSpec === 2) {
          // single erc1155 burn
          const c = new Creator1155Contract(onChainItem.contractAddress);
          uri = await c.uri(onChainItem.minTokenId?.toString() || '');
        }

        uri = convertPotentialWeb3ProtocolToWeb2(uri, onChainItem.minTokenId);

        const metadataResponse = await fetch(uri);
        jsonMetadata = await metadataResponse.json();
      } catch (e) {
        console.warn('Did not find name of token for burn group and burn item', e);
      }

      return jsonMetadata?.name || `Token ${onChainItem.minTokenId}`;
    } else {
      return `Tokens ${onChainItem.minTokenId} - ${onChainItem.maxTokenId}`;
    }
  }

  if (onChainItem.validationType === 3) {
    return `Tokens ${getTokenIdsForGroupItem(group)}`;
  }

  return '';
};

const formatListOfStrings = (arr: string[] | undefined) => {
  if (arr === undefined) {
    return '';
  }

  if (arr.length <= 1) {
    return arr[0] + ".";
  }
  return arr.slice(0, -1).join(", ") + " or " + arr.at(-1);
};

const getTokenIdsForGroupItem = (
  group: CoalescedBurnGroupOnChain,
): string => {
  const theSet = studioInstance.value?.publicData.burnSet;
  if (!theSet) {
    return '';
  }
  // find an equivalent group within studio burnSet to the provided on chain group
  const setIndex = theSet.findIndex((g) => {
    return g.items.every((item, i) => {
      const onChainItem = group.items[i];
      return (
        item.contractAddress.toLowerCase() === onChainItem.contractAddress.toLowerCase()
        && item.validationType === onChainItem.validationType
        && item.minTokenId?.toString() === onChainItem.minTokenId?.toString()
        && item.maxTokenId?.toString() === onChainItem.maxTokenId?.toString()
        && item.tokenSpec === onChainItem.tokenSpec
        && item.merkleRoot === onChainItem.merkleRoot
      );
    });
  });

  return formatListOfStrings(theSet[setIndex].items[0]?.tokenIds);
};

const burnGroupsAreIdentical = (a: BurnGroupOnChain, b: BurnGroupOnChain): boolean => {
  return a.items.every((item, i) => {
    return (
      item.contractAddress.toLowerCase() === b.items[i].contractAddress.toLowerCase()
      && item.validationType === b.items[i].validationType
      && item.minTokenId?.toString() === b.items[i].minTokenId?.toString()
      && item.maxTokenId?.toString() === b.items[i].maxTokenId?.toString()
      && item.tokenSpec === b.items[i].tokenSpec
      && item.merkleRoot === b.items[i].merkleRoot
    );
  });
};

watchEffect(async () => {
  if (!burn.value) {
    return;
  }

  coalcescedBurnGroups.value = [];

  const burnSetCopy = [
    ...burn.value.burnSet,
  ];

  for (let i = 0; i < burnSetCopy.length; i++) {
    const burnGroup = burnSetCopy[i];
    const duplicates = [];

    // remove any duplicates
    // do this backwards so we can splice out items as we go and not fuck up the outerloop
    for (let j = burnSetCopy.length - 1; j > i; j--) {
      const bg = burnSetCopy[j];
      if (burnGroupsAreIdentical(burnGroup, bg)) {
        duplicates.push(bg);
        burnSetCopy.splice(j, 1);
      }
    }

    const instanceItem = studioInstance.value?.publicData.burnSet
      ? studioInstance.value.publicData.burnSet[i]?.items[0]
      : undefined;

    // coalesce the duplicates into a single burn group
    let coalescedBurnGroup: CoalescedBurnGroupOnChain = {
      items: burnGroup.items,
      requiredCount: burnGroup.requiredCount,
      contractName: instanceItem?.contractName || abbreviateAddress(burnGroup.items[0].contractAddress).toUpperCase(),
    };

    if (duplicates.length) {
      duplicates.forEach((duplicate) => {
        coalescedBurnGroup.requiredCount = coalescedBurnGroup.requiredCount.add(duplicate.requiredCount);
      });
    } else {
      coalescedBurnGroup.requiredCount = burnGroup.requiredCount;
    }

    coalcescedBurnGroups.value.push(coalescedBurnGroup);
  }


  burnGroupDescriptions.value = [];
  for(let i = 0; i < coalcescedBurnGroups.value.length; i++) {
    burnGroupDescriptions.value.push(await getBurnGroupDescription(coalcescedBurnGroups.value[i]));
  }
});

const close = () => {
  emit('close');
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, null, {
    content: _withCtx(() => [
      _createElementVNode("span", {
        class: "absolute top-3 right-3 transition-all cursor-pointer hover:opacity-80",
        onClick: close
      }, _hoisted_2),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(coalcescedBurnGroups.value, (group, i) => {
          return (_openBlock(), _createElementBlock("div", { key: i }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (item, j) => {
              return (_openBlock(), _createElementBlock("div", {
                key: j,
                class: "mt-4"
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createTextVNode(_toDisplayString(item.amount.eq(0) ? group.requiredCount : item.amount.mul(group.requiredCount)) + "× ", 1),
                  _createElementVNode("span", null, _toDisplayString(group.contractName) + ", ", 1),
                  _createElementVNode("a", {
                    class: "inline text-sm",
                    target: "_blank",
                    href: getBurnItemLink(item)
                  }, [
                    (burnGroupDescriptions.value[i])
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(burnGroupDescriptions.value[i]), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_9, " ... "))
                  ], 8, _hoisted_7)
                ])
              ]))
            }), 128))
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }))
}
}

})